export default "__VITE_ASSET__15bd94a2__"